<!--  -->
<template>
  <div>
    <div style="display: flex; justify-content: flex-end;">
      <el-button type="primary" @click="handleButtonClick">一键解绑</el-button>
    </div>
    <div style="margin-top:10px">
      <el-dialog
        title="确认解绑"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        width="30%"
        @close="dialogVisible = false"
      >
        <span>确定要全部解绑吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="allUnBind">确定</el-button>
        </span>
      </el-dialog>
      <el-form label-position="right" label-width="130px">
        <el-form-item label="欢迎语绑定策略">
          <div v-if="welcome.length === 0">暂无欢迎语绑定策略</div>
          <div v-else>
            <el-tag
              v-for="(itemr, index) in welcome"
              :key="index"
              class="tag_box"
              closable
              @close="closetag(itemr, index)"
              @click="lookinfo(itemr)"
            >
              {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="定时绑定策略">
          <div v-if="timing.length === 0">暂无定时绑定策略</div>
          <div v-else>
            <el-tag
              v-for="(itemr, index) in timing"
              :key="index"
              class="tag_box"
              closable
              @close="closetag(itemr, index)"
              @click="lookinfo(itemr)"
            >
              {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="关键词延时">
          <div v-if="keyword.length === 0">暂无关键词绑定策略</div>
          <div v-else>
            <el-tag
              v-for="(itemr, index) in keyword"
              :key="index"
              class="tag_box"
              closable
              @close="closetag(itemr, index)"
              @click="lookinfo(itemr)"
            >
              {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="延时绑定策略">
          <div v-if="delayed.length === 0">暂无延时绑定策略</div>
          <div v-else>
            <el-tag
              v-for="(itemr, index) in delayed"
              :key="index"
              class="tag_box"
              closable
              @close="closetag(itemr, index)"
              @click="lookinfo(itemr)"
            >
              {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
            </el-tag>
          </div>
        </el-form-item>
        <div>
          <span style="margin-left: 60px; font-weight: bold">群聊策略</span>
          <el-form-item style="margin-left: 40px" label="群主">
            <div v-if="owner_strategy_text.length === 0">暂无群聊策略</div>
            <div v-else>
              <el-tag
                v-for="(itemr, index) in owner_strategy_text"
                :key="index"
                class="tag_box"
                @close="closetag(itemr, index)"
                @click="lookinfo(itemr)"
              >
                {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item style="margin-left: 40px" label="发言人">
            <div v-if="spoke_strategy_text.length === 0">暂无发言人策略</div>
            <div v-else>
              <el-tag
                v-for="(itemr, index) in spoke_strategy_text"
                :key="index"
                class="tag_box"
                @close="closetag(itemr, index)"
                @click="lookinfo(itemr)"
              >
                {{ itemr.sp_strategy_title }}({{ itemr.sp_strategy_no }})
              </el-tag>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  spCorpgetBindStrategy,
  spCorpremoveStrategy,
  getBindGroupStrategy, unBindEmpStrategy
} from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      employee_no: null,
      timing: [],
      delayed: [],
      keyword: [],
      welcome: [],
      owner_strategy_text: [],
      spoke_strategy_text: [],
      dialogVisible: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(employee_no) {
      this.employee_no = employee_no
      this.list()
    },
    async list() {
      const data = await spCorpgetBindStrategy({
        employee_no: this.employee_no
      })
      const res = await getBindGroupStrategy({
        employee_no: this.employee_no
      })
      this.owner_strategy_text = res.data.owner_strategy_text
      this.spoke_strategy_text = res.data.spoke_strategy_text
      this.timing = data.data.timing
      this.delayed = data.data.delayed
      this.keyword = data.data.keyword
      this.welcome = data.data.welcome
    },
    closetag(item, index) {
      this.$confirm('确定解绑策略吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          spCorpremoveStrategy({
            sp_strategy_no: item.sp_strategy_no,
            employee_no: this.employee_no
          }).then((res) => {
            this.$message({
              type: 'success',
              message: `${res.data.message}`
            })
            this.list()
            // this.arr.splice(index, 1)
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    lookinfo(item) {
      this.$router.push({
        path: '/enterprisemilist/index',
        query: { ids: item.sp_strategy_no }
      })
      this.$emit('closer')
    },
    handleButtonClick() {
      this.dialogVisible = true
    },
    async allUnBind() {
      if (this.delayed.length === 0 &&
        this.keyword.length === 0 &&
        this.timing.length === 0 &&
        this.welcome.length === 0 &&
        this.owner_strategy_text.length === 0 &&
        this.spoke_strategy_text.length === 0
      ) {
        this.$message({
          type: 'error',
          message: `目前暂时没有可以解绑的策略哦!请稍后再试`
        })
        this.dialogVisible = false
        return
      }
      const data = await unBindEmpStrategy({
        employee_no: this.employee_no
      })
      // eslint-disable-next-line eqeqeq
      if (data.code == 200) {
        this.$message({
          type: 'success',
          message: `${data.message}`
        })
        this.dialogVisible = false
        this.$emit('closer')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tag_box {
  margin: 0 10px 10px 0px;
}
</style>
